import { makeAutoObservable } from "mobx";
import {
  getHealthOrg,
  createHealthOrg,
  editHealthOrg,
  deleteHealthOrg,
  checkCode,
  getChidrenByParent,
} from "../HealthOganizationUnitService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

export default class healthOrgDetailStore {
  selectedDetailHealthOrg = null;
  selectedSubHealthOrg = null;
  // healthOrgList = [];
  // selectedhealthOrgList = [];
  // totalElements = 0;
  // totalPages = 0;
  // page = 1;
  // rowsPerPage = 10;
  // keyword = "";
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  shouldOpenConfirmationDialog = false;
  shouldOpenConfirmationDeleteListDialog = false;

  //ds đơn vị trực thuộc
  subHealthOrgList = [];
  selectedSubHealthOrgList = [];
  subHealthOrgTotalPages = 0;
  subHealthOrgTotalElements = 0;
  subHealthOrgRowsPerPage = 5;
  subHealthOrgPage = 1;
  subHealthOrgKeyWord = "";

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  getDetailHealthOrg = async (id) => {
    this.loadingInitial = true;
    if (id != null) {
      try {
        let res = await getHealthOrg(id);
        this.handleSelectHealthOrg(res.data);
        this.subHealthOrgUpdatePageData();
        return this.selectedDetailHealthOrg;
      } catch (error) {
        console.log(error);
        toast.warning("toast.get_fail");
      }
    } else {
      this.handleSelectHealthOrg(null);
    }
    this.setLoadingInitial(false);
  };

  getSubHealthOrg = async (id) => {
    if (id != null) {
      try {
        let res = await getHealthOrg(id);
        this.selectedSubHealthOrg = res.data;
        return res.data;
      } catch (error) {
        console.log(error);
        toast.warning("toast.get_fail");
      }
    } else {
      this.selectedSubHealthOrg = null;
    }
  };

  handleSelectHealthOrg = (healthOrg) => {
    this.selectedDetailHealthOrg = healthOrg;
  };

  //ds đơn vị trực thuộc

  subHealthOrgSetPage = (page) => {
    this.subHealthOrgPage = page;
    this.subHealthOrgUpdatePageData();
  };

  subHealthOrgSetRowsPerPage = (event) => {
    this.subHealthOrgRowsPerPage = event.target.value;
    this.subHealthOrgPage = 1;
    this.subHealthOrgUpdatePageData();
  };

  subHealthOrgHandleChangePage = (event, newPage) => {
    this.subHealthOrgSetPage(newPage);
  };

  subHealthOrgUpdatePageData = (item) => {
    if (item != null) {
      this.subHealthOrgPage = 1;
      this.subHealthOrgKeyword = item.keyword;
      this.subHealthOrgSearch();
    } else {
      this.subHealthOrgSearch();
    }
  };

  subHealthOrgSearch = async () => {
    var searchObject = {
      keyword: this.subHealthOrgKeyword,
      pageIndex: this.subHealthOrgPage,
      pageSize: this.subHealthOrgRowsPerPage,
      parentId: this.selectedDetailHealthOrg?.id,
    };

    try {
      let data = await getChidrenByParent(searchObject);
      this.subHealthOrgList = data.data.content;
      this.subHealthOrgTotalElements = data.data.totalElements;
      this.subHealthOrgTotalPages = data.data.totalPages;
    } catch (error) {
      console.log(error);
      toast.warning("toast.load_fail");
    }
  };

  subHealthOrgHandleEdit = (id) => {
    this.getSubHealthOrg(id).then(() => {
      this.shouldOpenEditorDialog = true;
    });
  };

  subHealthOrgHandleClose = () => {
    this.shouldOpenEditorDialog = false;
    this.shouldOpenConfirmationDialog = false;
    this.shouldOpenConfirmationDeleteListDialog = false;
    this.subHealthOrgUpdatePageData();
  };

  subHealthOrgHandleDelete = (id) => {
    this.getSubHealthOrg(id).then(() => {
      this.shouldOpenConfirmationDialog = true;
    });
  };

  subHealthOrgHandleDeleteList = () => {
    this.shouldOpenConfirmationDeleteListDialog = true;
  };

  subHealthOrgHandleConfirmDelete = async () => {
    try {
      const res = await deleteHealthOrg(this.selectedSubHealthOrg.id);
      if (res?.data) {
        toast.success("Đã xoá bản ghi");
      } else {
        toast.warning("Không thể xoá vì có dữ liệu ràng buộc");
      }
      this.subHealthOrgHandleClose();
    } catch (error) {
      console.log(error);
      toast.error("Có lỗi xảy ra, vui lòng thử lại sau");
    }
  };

  subHealthOrgHandleConfirmDeleteList = async () => {
    let listAlert = [];
    for (var i = 0; i < this.selectedSubHealthOrgList.length; i++) {
      try {
        await deleteHealthOrg(this.selectedSubHealthOrgList[i].id);
      } catch (error) {
        listAlert.push(this.selectedSubHealthOrgList[i].name);
        toast.warning("toast.delete_fail");
      }
    }
    this.subHealthOrgHandleClose();
    toast.success("Đã xóa thành công!");
  };

  subHealthOrgHandleSelectList = (healthOrgs) => {
    this.selectedSubHealthOrgList = healthOrgs;
    // console.log(this.selectedSubHealthOrgList);
  };

  createHealthOrg = async (healthOrg) => {
    try {
      let response = await checkCode(healthOrg);
      if (response.data) {
        toast.warning("Mã đã được sử dụng!");
      } else {
        await createHealthOrg(healthOrg);
        toast.success("Thêm mới thành công!");
        this.subHealthOrgHandleClose();
      }
    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi thêm mới!");
    }
  };

  editHealthOrg = async (healthOrg) => {
    try {
      let response = await checkCode(healthOrg);
      if (response.data) {
        toast.warning("Mã đã được sử dụng!");
      } else {
        await editHealthOrg({...healthOrg, adminUnit: undefined});
        toast.success("Cập nhật thành công!");
        this.subHealthOrgHandleClose();
      }
    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi cập nhật!");
    }
  };

  //done sub healthOrg

}
